import { useMemo } from "react";
import { useParams } from "react-router-dom";

import { REPORT_TYPE_AUDIOLOGY } from "constants/audiology";
import {
  PATIENT_HEADER_AUDIOGRAM_QUERY,
  useGetReportsQuery
} from "services/reports";
import type { Report } from "services/types/reports.type";

export default function usePatientHeaderReports(
  patientId?: number,
  skip = false
): {
  latestAudiogram: Report | undefined;
  isLatestAudiogramLoading: boolean;
} {
  const { patientId: paramPatientId = "" } = useParams();
  const currentPatientId =
    patientId ?? (paramPatientId ? Number.parseInt(paramPatientId) : -1);

  const {
    data: latestFetchedAudiograms,
    isLoading,
    isFetching
  } = useGetReportsQuery(
    {
      patientId: currentPatientId,
      limit: 1,
      type: REPORT_TYPE_AUDIOLOGY,
      has_audiogram: true,
      query: PATIENT_HEADER_AUDIOGRAM_QUERY,
      ordering: "-report_date,-pk"
    },
    {
      skip: skip || !currentPatientId || currentPatientId === -1
    }
  );

  const latestAudiogram = useMemo(() => {
    return currentPatientId && currentPatientId !== -1
      ? latestFetchedAudiograms?.at(0)
      : undefined;
  }, [latestFetchedAudiograms, currentPatientId]);

  return {
    latestAudiogram,
    isLatestAudiogramLoading:
      isLoading || (isFetching && latestFetchedAudiograms === undefined)
  };
}
